import type { StatusTone } from '@vnetwork/ui/data';

/**
 * Maps a VOD/Live job status string to a StatusPill tone.
 * Uses substring matching to handle both canonical names and composite
 * statuses like "distribute-failed", "pulling-failed".
 *
 * Canonical tone mapping (runtime statuses → StatusPill; Badge for categories):
 *   success  — completed, distributed
 *   danger   — failed, error, cancelled
 *   warning  — pending
 *   info     — running, transcoding, downloading, pulling
 *   neutral  — unknown / unrecognised
 */
export function jobStatusTone(status?: string | null): StatusTone {
  const s = (status ?? '').toLowerCase();
  if (s.includes('complet') || s.includes('distribut')) return 'success';
  if (s.includes('fail') || s.includes('error') || s.includes('cancel')) return 'danger';
  if (s.includes('pending')) return 'warning';
  if (
    s.includes('running') ||
    s.includes('transcod') ||
    s.includes('download') ||
    s.includes('pull')
  )
    return 'info';
  return 'neutral';
}
